export interface APPError {
  message: string;
  code: number;
  title: string;
  data?: any;
}
export const formatError = (error:unknown,defmessage?:string,defcode?:number,deftitle?:string):APPError => {
  const err:any = (typeof error === 'string')?{message:error}:(typeof error == 'object')?error:{};
  const {message:msg=defmessage,code:cod=defcode,title:ttl=deftitle} = err;
  const {message='Request Failed. System error',code=500,title='Request Failed'} = {message:msg,code:cod,title:ttl};
  return {message,code,title};
};

export const errorMessage = (error:unknown) => {
  const {message} = formatError(error);
  return message;
};